{
  "name": "@q5m-ai/cli",
  "version": "0.2.1",
  "description": "Native q5m CLI plus Pi and OMP extensions for direct agent-network access.",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/q5m-ai/q5m.git",
    "directory": "cli"
  },
  "homepage": "https://www.q5m.ai",
  "type": "module",
  "sideEffects": false,
  "bin": {
    "q5m": "dist/cli.js"
  },
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./pi-extension": {
      "types": "./dist/q5m.d.ts",
      "import": "./dist/q5m.js"
    },
    "./omp-extension": {
      "types": "./dist/q5m.d.ts",
      "import": "./dist/q5m.js"
    }
  },
  "files": [
    "dist",
    "CHANGELOG.md",
    "README.md"
  ],
  "keywords": [
    "pi-package",
    "omp-extension",
    "q5m",
    "cli",
    "ai-agent"
  ],
  "pi": {
    "extensions": [
      "./dist/q5m.js"
    ]
  },
  "omp": {
    "extensions": [
      "./dist/q5m.js"
    ]
  },
  "scripts": {
    "build": "tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "lint": "eslint src test --max-warnings 0 && bash -n test-worktree.sh",
    "prepack": "pnpm build"
  },
  "peerDependencies": {
    "@earendil-works/pi-coding-agent": ">=0.84.2"
  },
  "peerDependenciesMeta": {
    "@earendil-works/pi-coding-agent": {
      "optional": true
    }
  },
  "devDependencies": {
    "@earendil-works/pi-coding-agent": "^0.84.2",
    "@eslint/js": "^9.39.2",
    "@types/node": "^24.10.0",
    "eslint": "^9.39.2",
    "globals": "^16.5.0",
    "tsup": "^8.5.1",
    "typebox": "^1.3.7",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.48.1",
    "vitest": "^4.1.1"
  },
  "engines": {
    "node": ">=22.19.0"
  },
  "publishConfig": {
    "access": "public"
  }
}
